<template>
  <div>
    <list-template
      :search-config="searchConfig"
      @onSearch="onSearch"
      @onReset="onReset"
      :table-config="tableConfig"
      :table-data="tableData"
      :total="total"
      :loading="loading"
      :current-page="page"
      @onChangePage="handleCurrentChange"
      @onHandle="handleClick"
      @onChange="onChange"
      @onBatchImport ="handBatchImport "
      @onBatchImportQuota ="handleBatchImportQuota"
      @onExportAll ="handleExportAll"
    >
    </list-template>
    <Dialog :visible.sync="visible1" title="导入数据" size="small" buttonAlign="center" submitText="关闭" :showCancelButton="false" :showFooter="true" :closeOnClickModal="false">
      <div class="px-2">
        <el-form ref="form" :model="formData" :rules="rules" label-position="left" label-width="120rem" >
          <el-form-item label="参考城市" prop="city">
            <el-cascader v-model="formData.city" :options="areaOptions"></el-cascader>
          </el-form-item>
          <el-form-item label="入学年份" prop="year" style="display: none;">
            <el-select v-model="formData.year">
              <el-option v-for="i in yearOptions" :key="i.value" :label="i.label" :value="i.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="下载模板">
            <el-button size="small" icon="el-icon-download" @click="handleSubmit(0)">下载</el-button>
          </el-form-item>
          <el-form-item label="上传数据">
            <el-button type="primary" size="small" icon="el-icon-upload2" @click="handleSubmit(1)">上传</el-button>
          </el-form-item>
        </el-form>
      </div>
    </Dialog>
    <Dialog :visible.sync="visible2" title="导入数据" size="small" buttonAlign="center" submitText="关闭" :showCancelButton="false" :showFooter="true" :closeOnClickModal="false">
      <div class="px-2">
        <el-form ref="form" :model="formData" :rules="rules" label-position="left" label-width="120rem" >
          <el-form-item label="下载模板">
            <el-button size="small" icon="el-icon-download" @click="handleDownYiTi">下载</el-button>
          </el-form-item>
          <el-form-item label="上传数据">
            <el-button type="primary" size="small" icon="el-icon-upload2" @click="handleSubmitYiTi">上传</el-button>
          </el-form-item>
        </el-form>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/common/Dialog"
import { tableListMixin, getAreaDataMixin } from '@/utils/mixins'
import { zsPost, fileDownload, getEnrollmentYear } from '@/api'
import { setConfigOption, handleChooseFile } from '@/utils'
export default {
	_config:{"route":{"path":"list","meta":{"title":"列表"}}},
  mixins: [tableListMixin,getAreaDataMixin],
  components: { Dialog },
  created() {
    this.getAreaData()
    this.getConfig()
  },
  methods: {
    getConfig() {
      const year = new Date().getFullYear()
      this.formData.year = year
      getEnrollmentYear().then(res => {
        this.yearOptions = res
        setConfigOption({ list: this.searchConfig, data: res, key: 'year' })
      })
    },
    getData() {
      this.getDataApi('/zhaosheng/api/recruit-2024/exam/list-student-policy')
    },
    handleClick(row, handle) {
      const { type } = handle
      if(type === 'delete') {
        this.$confirm('是否继续删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          zsPost('/recruit-2024/exam/del-student-policy', { id: row.id }).then(() => {
            this.$message.success('删除成功')
            this.getData()
          })
        })
      }
    },
    handBatchImport () {
      this.visible1 = true
      this.type = 0
    },
    handleBatchImportQuota() {
      this.visible1 = true
      this.type = 1
    },
    handleSubmit(type) {
      if(type) {
        this.handleSelectFile()
        this.$refs['form'].clearValidate(['city'])
        return
      }
      this.$refs['form'].validate(valid => {
        if(valid) {
          const city_code = this.formData.city[1]
          this.handleDownFile(city_code, this.formData.year)
        }
      })
    },
    handleExportAll() {
      this.visible2 = true
    },
    handleDownYiTi() { 
      const config = { name: '艺体生导入 ', type: 'xlsx' }
      fileDownload('/zhaosheng/api/recruit-2024/exam/export-yiti-tmpl', {}, config)
    },
    handleSubmitYiTi() {
      handleChooseFile({
        api: '/zhaosheng/api/recruit-2024/exam/import-yiti-tmpl',
        show: true,
        onSuccess: () => {
          this.$message.success('导入成功')
          this.visible2 = false
          this.getData()
        }
      })
    },
    handleSelectFile() {
      handleChooseFile({
        api: '/zhaosheng/api/recruit-2024/exam/import-diag-tmpl',
        data: { is_quota_school: this.type },
        show: true,
        html: true,
        onSuccess: () => {
          this.$message.success('导入成功')
          this.visible1 = false
          this.getData()
        }
      })
    },
    handleDownFile(city_code, year) {
      const config = { name: this.type ? '指标到校生' : '容缺政策人员 ', type: 'xlsx' }
      fileDownload('/zhaosheng/api/recruit-2024/exam/export-diag-tmpl', {city_code, year}, config)
    }
  },
  data() {
    return {
      visible1: false,
      visible2: false,
      type: 0,
      yearOptions: [],
      formData: { city: '', year: '' },
      rules: {
        city: [{ required: true, message: '请选择', trigger: 'change' }],
        year: [{ required: false, message: '请选择', trigger: 'change' }],
      },
      tableConfig: [
        { prop: 'student_name', label: '学生姓名' },
        { prop: 'year', label: '入学年份' },
        { prop: 'id_card', label: '学生身份证号' },
        { prop: 'is_quota_school_name', label: '学生享受政策' },
        { prop: 'direction', label: '专业方向' },
        { prop: 'max_score', label: '考试总分' },
        { prop: 'creator', label: '创建人' },
        { prop: 'created_at', label: '创建时间' },
        { label: '操作', width: '110rem', handle: true }
      ],
      searchConfig: [
        { tag: 'input', placeholder: '搜索姓名', prop: 'student_name' },
        { tag: 'select', placeholder: '筛选学生享受政策', prop: 'is_quota_school', options: [
          { label: '容缺人员', value: 0 },
          { label: '指标到校生', value: 1 },
          { label: '艺体生', value: 2 },
        ] },
        { placeholder: '筛选入学年份', prop: 'year', tag: 'select', options: [] }
      ]
    }
  },
}
</script>

<style lang="scss" scoped></style>
